import React, { Component } from "react";
import "./CategoryRow.css";
class CategoryRow extends Component {
    constructor(props) {
        super(props);

        this.imageFormRef = React.createRef();
        this.fileInputRef = React.createRef();
    }
    state = { category: this.props.category };

    render() {
        let { category } = this.state;
        let { name, image } = category;
        return (
            <div
                className='categoryRow'
                draggable
                onDragOver={(ev) => {
                    ev.preventDefault();
                }}
                key={name}
                onDragStart={(ev) => {
                    this.props.onDrag(category);
                }}
                onDrop={(ev) => {
                    ev.preventDefault();
                    this.props.onDrop(category);
                }}
            >
                <div className='name'>{name}</div>
                <div className='img'>
                    <img src={image} draggable='false' />
                </div>

                <div className='actions'>
                    <div
                        className='delete'
                        onClick={(ev) => this.props.delete(category)}
                    >
                        <i className='fa-regular fa-trash-can'></i>
                    </div>
                    <div
                        className='edit'
                        onClick={(ev) => this.props.edit(name)}
                    >
                        <i className='ri-edit-2-fill'></i>
                    </div>
                </div>
            </div>
        );
    }
}

export default CategoryRow;
